import React from 'react';
import { styled } from 'styled-components';
import colors from '../../../styles/colors';
import { preventEnterSubmit } from '../../../helpers/formHelper';

interface TimeSlotProps {
  id: string;
  from: string;
  to: string;
  selected: boolean;
  onSelectTimeSlot: (id: string) => void;
}

const StyledSlotContainer = styled.div`
  position: relative;
  margin-top: 8px;
`;

const VisuallyHiddenRadio = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;

  &:focus {
    outline: none;
  }
`;

const StyledLabel = styled.label<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  min-height: 2rem;
  height: 2rem;
  padding: 0 14px;
  border-radius: 64px;
  cursor: pointer;
  background: ${({ $selected }) =>
    $selected ? colors.interactive.emphasised : colors.interactive.default};
  color: ${({ $selected }) =>
    $selected ? colors.static.white : colors.text.black};

  &:hover {
    background: ${({ $selected }) =>
      $selected
        ? colors.interactive.emphasisedHover
        : colors.interactive.defaultHover};
  }

  &:focus-within {
    outline: 3px solid ${colors.interactive.borderEmphasised};
    outline-offset: 2px;
  }
`;

const TimeSlot: React.FC<TimeSlotProps> = ({
  id,
  from,
  to,
  selected,
  onSelectTimeSlot,
}) => (
  <StyledSlotContainer>
    <StyledLabel $selected={selected} data-cy={`time-slot-${from}-${to}`}>
      <VisuallyHiddenRadio
        type="radio"
        name="timeslot"
        value={id}
        checked={selected}
        onChange={() => onSelectTimeSlot(id)}
        onKeyDown={preventEnterSubmit}
      />
      {from} - {to}
    </StyledLabel>
  </StyledSlotContainer>
);

export default TimeSlot;
